import { redirect } from '@tanstack/react-router';
import { ApiError, meQuery, queryClient } from './api.ts';
import { safeReturnTo } from './return-to.ts';
export async function redirectSignedIn({
  search,
  location,
}: {
  search: { returnTo?: string; oauthQuery?: string };
  location: { searchStr: string };
}) {
  if (
    search.oauthQuery ||
    new URLSearchParams(location.searchStr).has('sig') ||
    safeReturnTo(search.returnTo).startsWith('/super/authorize?')
  )
    return;
  try {
    await queryClient.fetchQuery(meQuery);
  } catch (error) {
    if (error instanceof ApiError && error.status === 401) return;
    throw error;
  }
  throw redirect({ to: '/', replace: true });
}
